module.exports = __webpack_public_path__ + "static/media/L2.c63a6c1f.jpg";